class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
      document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
      document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
      document.body.classList.remove("overflow-hidden-tablet");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    if(document.querySelector(".header__search details").hasAttribute("open")){
      document.querySelector(".header__search details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  // The empty state is driven by .is-empty on <cart-drawer> itself
  // (cart-drawer.is-empty hides the header, and :not(.is-empty) hides the empty
  // message), but renderContents only ever replaces what is *inside* #CartDrawer
  // -- the host element keeps whatever classes it already had. So the class has to
  // be taken from the section that was just rendered, otherwise emptying the cart
  // through a path that ends in renderContents leaves empty markup styled as a
  // filled cart: header visible, empty message hidden.
  setEmptyStateFromSection(sectionHTML) {
    if (!sectionHTML) return;
    const source = this.getSectionDOM(sectionHTML, 'cart-drawer');
    if (!source) return;

    this.classList.toggle('is-empty', source.classList.contains('is-empty'));
  }

  renderContents(parsedState,discount,discountcode) {
    this.setEmptyStateFromSection(parsedState.sections && parsedState.sections['cart-drawer']);
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      // console.log(parsedState.sections[section.id],"parsedState.sections[section.id]")
      if(discount){
        const parser = new DOMParser();
        let CARThtml = parser.parseFromString(parsedState.sections[section.id], "text/html");
        var discount_applied = false;
        if(CARThtml.querySelector("ul.discounts.list-unstyled")){
          CARThtml.querySelectorAll("ul.discounts.list-unstyled").forEach((ele) => {
            if(ele.innerHTML){
              discount_applied = true;
              return false;
            }
          })
          if(discount_applied){
            console.log("discount applied",discount_applied)
            setTimeout(function(){
              document.querySelector("cart-coupon-form .error").classList.add("d-none");
              }, 500);
          }else{
            setTimeout(function(){
              let pre_Val = discountcode;
              document.querySelector(".promo-code-wrap").classList.add("open");
              document.querySelector("cart-coupon-form .error").classList.remove("d-none");
              document.querySelector("cart-coupon-form input[type='text']").value = pre_Val;
            }, 500);
            
          }
        }
      }
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//Coupon Code
class PromoCodeSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.target.classList.contains('cart-coupon-main') ? this.querySelector('.promo-code-wrap').classList.toggle('open') : null;
  
    });
  }
}

customElements.define('promo-code-wrap', PromoCodeSection);


// Gift products collapsible row
class GiftProductsRow extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.wrap = this.querySelector('.gift-products-wrap');
    this.toggleButton = this.querySelector('.gift-products-main');
    this.listHolder = this.querySelector('.gift-products-list-holder');
    this.errorElement = this.querySelector('.gift-products-error');
    if (!this.wrap || !this.toggleButton) return;

    // The drawer is re-rendered from the server on every cart change, so the open
    // state has to be restored here: keep the row open while a gift is selected,
    // and remember whatever the shopper last chose.
    if (GiftProductsRow.isOpen || this.hasSelection()) this.setOpen(true);

    this.toggleButton.addEventListener('click', this.onToggle.bind(this));
    this.toggleButton.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.onToggle();
    });

    this.querySelectorAll('.gift-product__checkbox').forEach((checkbox) => {
      checkbox.addEventListener('change', this.onSelectionChange.bind(this));
    });

    this.updateLimitState();
    this.openWhenShippingQualifies();

    // Measure after layout so the list is sized before we look at its width.
    requestAnimationFrame(() => this.updateScrollState());
    this.resizeHandler = this.updateScrollState.bind(this);
    window.addEventListener('resize', this.resizeHandler);
  }

  disconnectedCallback() {
    if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
  }

  hasSelection() {
    return !!this.querySelector('.gift-product__checkbox:checked');
  }

  // 0 (or a missing/invalid value) means the shopper can pick as many as they like.
  get limit() {
    const limit = parseInt(this.dataset.limit, 10);
    return Number.isNaN(limit) || limit < 0 ? 0 : limit;
  }

  get selectedCount() {
    return this.querySelectorAll('.gift-product__checkbox:checked').length;
  }

  // "Working with shipping": gifts stay locked until the cart earns free shipping.
  get isLocked() {
    return this.dataset.gate === 'true' && this.dataset.gateMet === 'false';
  }

  // Mirrors what the Liquid renders, so the shopper sees the checkboxes enable or
  // disable straight away instead of waiting for the cart request to come back.
  updateLimitState() {
    const limit = this.limit;
    const locked = this.isLocked;
    const reached = limit > 0 && this.selectedCount >= limit;

    this.querySelectorAll('.gift-product__checkbox').forEach((checkbox) => {
      const giftProduct = checkbox.closest('.gift-product');
      const soldOut = checkbox.dataset.available === 'false';
      // A ticked gift always stays enabled, otherwise it could never be unticked --
      // which matters here because the cart can drop back below the threshold.
      const blockedByGate = locked && !checkbox.checked;
      const blockedByLimit = !locked && reached && !checkbox.checked;

      checkbox.disabled = !checkbox.checked && (blockedByGate || blockedByLimit || soldOut);
      if (giftProduct) {
        giftProduct.classList.toggle('gift-product--gate-blocked', blockedByGate);
        giftProduct.classList.toggle('gift-product--limit-blocked', blockedByLimit);
      }
    });
  }

  // Expand the row the moment the cart qualifies for free shipping. Tracked on the
  // transition into "qualifies" rather than on every render, so a shopper who
  // collapses the row afterwards is not fought on the next cart update.
  openWhenShippingQualifies() {
    if (this.dataset.gate !== 'true') return;
    const qualifies = this.dataset.gateMet === 'true';
    if (qualifies && GiftProductsRow.shippingQualified !== true) this.setOpen(true);
    GiftProductsRow.shippingQualified = qualifies;
  }

  onToggle() {
    this.setOpen(!this.wrap.classList.contains('open'));
  }

  setOpen(open) {
    this.wrap.classList.toggle('open', open);
    this.toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    GiftProductsRow.isOpen = open;
    if (open) requestAnimationFrame(() => this.updateScrollState());
  }

  // The list only needs to reserve room for a scrollbar once it overflows.
  updateScrollState() {
    if (!this.listHolder) return;
    const scrollable = this.listHolder.scrollWidth > this.listHolder.clientWidth + 1;
    this.listHolder.classList.toggle('is-scrollable', scrollable);
  }

  onSelectionChange(event) {
    const checkbox = event.currentTarget;
    const giftProduct = checkbox.closest('.gift-product');
    const wasChecked = checkbox.checked;

    this.clearError();

    // Refuse the tick if the cart has not earned free shipping yet, or if it would
    // go past the limit. Nothing has been sent to the cart yet, so undoing it here
    // is enough.
    if (wasChecked && this.isLocked) {
      checkbox.checked = false;
      this.updateLimitState();
      this.showError(this.dataset.lockedMessage);
      return;
    }

    if (wasChecked && this.limit > 0 && this.selectedCount > this.limit) {
      checkbox.checked = false;
      this.updateLimitState();
      this.showError(this.dataset.limitMessage);
      return;
    }

    if (giftProduct) giftProduct.classList.add('is-loading');
    this.updateLimitState();

    const request = wasChecked ? this.addToCart(checkbox) : this.removeFromCart(checkbox);

    request
      .then((parsedState) => {
        if (parsedState.status) {
          throw new Error(parsedState.description || parsedState.message);
        }
        // Keep the row expanded across the re-render so the shopper still sees
        // the selection they just made.
        GiftProductsRow.isOpen = true;
        // Do not publish PUB_SUB_EVENTS.cartUpdate here. CartItems subscribes to it
        // and its onCartUpdate() pulls the *cart page* section (main-cart-items) into
        // whichever element received the event -- including this drawer's
        // <cart-drawer-items>, which replaces the drawer list with cart page markup.
        // renderContents() below already refreshes the drawer and the cart bubble.
        const cartDrawer = document.querySelector('cart-drawer');
        cartDrawer.renderContents(parsedState);
      })
      .catch((error) => {
        // Put the checkbox back the way it was so it keeps matching the cart.
        checkbox.checked = !wasChecked;
        if (giftProduct) giftProduct.classList.remove('is-loading');
        this.updateLimitState();
        this.showError(error.message || (window.cartStrings && window.cartStrings.error));
      });
  }

  addToCart(checkbox) {
    return fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(checkbox.value), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then((response) => response.json());
  }

  removeFromCart(checkbox) {
    return fetch(`${routes.cart_change_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: checkbox.dataset.lineKey || checkbox.value,
        quantity: 0,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then((response) => response.json());
  }

  showError(message) {
    if (!this.errorElement || !message) return;
    this.errorElement.textContent = message;
    this.errorElement.classList.remove('hidden');
  }

  clearError() {
    if (!this.errorElement) return;
    this.errorElement.textContent = '';
    this.errorElement.classList.add('hidden');
  }
}

GiftProductsRow.isOpen = false;

customElements.define('gift-products-row', GiftProductsRow);


class CartCouponCodeButton extends HTMLElement {
  constructor() {
    super();
    let current_form = this;
    this.querySelector('#coupon-form').addEventListener('submit', (event) => {

      event.preventDefault();
      this.submitForm(current_form.querySelector('.promo-input.couponCode').value)
    });
  }
 

   applyCouponCode(discountCode) {
    return new Promise((resolve, reject) => {
      let discountApplyUrl = "https://" + window.location.host + "/discount/" + discountCode;
  
      // Create a hidden iframe to apply discount using the checkout session
      let i = document.createElement('iframe');
      i.style.display = 'none';
      
      // Success: Remove iframe after it loads and log success message
      i.onload = function() {
        console.log("Discount code applied successfully."); // Log success
        i.parentNode.removeChild(i); // Clean up the iframe
        resolve(); // Resolve the promise for success
      };
  
      // Error: Handle iframe loading error
      i.onerror = function() {
        console.error("Failed to apply discount code."); // Log error message
        i.parentNode.removeChild(i); // Clean up the iframe
        reject(new Error("Failed to apply discount code.")); // Reject with error
      };
  
      i.src = discountApplyUrl;
      document.body.appendChild(i); // Append iframe to the body
    });
  }
  
  submitForm(discountCode){
    let current_this = this
    current_this.applyCouponCode(discountCode)
    .then(() => {
        console.log("Discount applied successfully!");
        fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((response) => response.json())
        .then((response) => {
            let responseFormated = {
                sections: response
            }
            let cart_drawer = document.querySelector('cart-drawer');
            cart_drawer.renderContents(responseFormated,"discount",discountCode)
            
        })
      })
    .catch(error => {
        console.error("Error applying discount:", error.message);
    });
  }
}

customElements.define('cart-coupon-form', CartCouponCodeButton);




